import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Box, Flex, Text, Stack, Card, CardHeader } from "@chakra-ui/react";

import { selectActiveProperties } from "../../../redux/user/userSlice";
import { getPropertyAddress } from "../../../utils/verifier";

import PropertyPaymentsCard from "./PropertyPaymentsCard";

export default function Payments() {
	const { t } = useTranslation();
	const stripeCustomerId = useSelector((state) => state.user.user?.stripeCustomerId);
	const email = useSelector((state) => state.user.user?.email);
	const name = useSelector((state) => state.user.user?.name);
	const phoneNumber = useSelector((state) => state.user.user?.phoneNumber);
	const properties = useSelector(selectActiveProperties);

	return (
		<Stack>
			<Card overflowX={{ sm: "scroll", xl: "hidden" }}>
				<CardHeader>
					<Flex direction={"row"}>
						<Box style={{ marginRight: "15px" }}>
							<Text fontSize="xl" fontWeight="bold">
								{t("navbarMenu.payments")}
							</Text>
						</Box>
						{/* <Box>
							<Input type="text" placeholder="Search..." value={query} onChange={handleSearchChange} />
						</Box> */}
					</Flex>
				</CardHeader>
			</Card>
			{properties.map((property, index) => {
				const payments = property.payments;
				return (
					<PropertyPaymentsCard
						payments={payments}
						address={getPropertyAddress(property)}
						propertyId={property.id}
						stripeCustomerId={stripeCustomerId}
						name={name}
						email={email}
						phoneNumber={phoneNumber}
						key={index}
					/>
				);
			})}
		</Stack>
	);
}
